import { useContext, useEffect } from 'react';
import { loadScript } from '@buzzfeed/bf-utils/lib/load-script';
import BuzzContext from '../../contexts/buzz';

const ChartbeatAnalytics = () => {
  const buzz = useContext(BuzzContext);
  
  const getSection = ({ category, classification, all_classifications }) => {
    if (!(category || classification || all_classifications)) {
      return '';
    }
    const sections = [category, classification.sections];
    return [...new Set([...all_classifications.sections, ...sections])].join(', ');
  };

  const getAuthor = ({ bylines }) => {
    const authors = bylines.map(a => a.display_name || a.username);
    return authors.join(', ');
  };
  
  const authorNames = getAuthor(buzz);
  const sectionNames = getSection(buzz);  

  const inline_js = `(function() {
    /** CONFIGURATION START **/
    var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
    _sf_async_config.uid = 66952;
    _sf_async_config.domain = 'buzzfeed.com';
    _sf_async_config.flickerControl = false;
    _sf_async_config.useCanonical = true;
    _sf_async_config.useCanonicalDomain = true;
    _sf_async_config.sections = '${sectionNames}';
    _sf_async_config.authors = '${authorNames}'
    /** CONFIGURATION END **/
    function loadChartbeat() {      
        var e = document.createElement('script');
        var n = document.getElementsByTagName('script')[0];
        e.type = 'text/javascript';
        e.async = true;
        e.src = '//static.chartbeat.com/js/chartbeat.js';
        n.parentNode.insertBefore(e, n);
    }
    loadChartbeat();
  })();`

  // Append inline js
  useEffect(
    () => {
      if (authorNames || sectionNames) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = inline_js;
        document.head.appendChild(script);
        loadScript('https://static.chartbeat.com/js/chartbeat_mab.js');
      }
    },
    [authorNames, sectionNames]
  );


  return null;
};

export default ChartbeatAnalytics;
